export var THUMBNAIL_SIZE = '64px';